import { HttpSapErrorModel } from './http-sap-error.model';

export class HttpErrorContainerModel {
    public sapValidationErrors: HttpSapErrorModel[] = [];

    public hasErrors(): boolean {
        return this.sapValidationErrors.length > 0;
    }
}
